import './ajax.js';
jQuery(function ($) {
    $(document).ready(function () {


        // ======================================
        // memnu hamburgue
        // ======================================
        const pcMenuBtn = document.querySelector('.pc-menu-btn');
        const pcMenuBox = document.querySelector('.pc-menu-box');

        if (pcMenuBtn && pcMenuBox) {
            pcMenuBtn.addEventListener('click', function () {
                pcMenuBtn.classList.toggle('pc--open');
                pcMenuBox.classList.toggle('pc-menu-active');

                // Força o display flex quando ativo
                if (pcMenuBox.classList.contains('pc-menu-active')) {
                    pcMenuBox.style.setProperty('display', 'flex', 'important');
                } else {
                    pcMenuBox.style.removeProperty('display');
                }
            });

            // Fecha o menu quando clicar em um link (melhor UX no mobile)
            pcMenuBox.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', () => {
                    pcMenuBtn.classList.remove('pc--open');
                    pcMenuBox.classList.remove('pc-menu-active');
                });
            });
        }
        // ======================================
        // Swiper do banner big publi 
        // ======================================
        // SLIDER 1 – .publi-slider
        const publi1 = new Swiper('.publi-slider', {
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 500,
            navigation: {
                nextEl: '.next-1',
                prevEl: '.prev-1',
            },
        });

        const publi2 = new Swiper('.publi-slider-2', {
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 500,
            navigation: {
                nextEl: '.next-2',
                prevEl: '.prev-2',
            },
        });

        const publi3 = new Swiper('.publi-slider-3', {
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 500,
            navigation: {
                nextEl: '.next-3',
                prevEl: '.prev-3',
            },
        });

        const publi4 = new Swiper('.publi-slider-4', {
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 500,
            navigation: {
                nextEl: '.next-4',
                prevEl: '.prev-4',
            },
        });




        // ======================================
        // Swiper dos destaques
        // ======================================

        const thumbs = new Swiper('.destaque-thumbs', {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            loop: true,
        });

        const mainSlider = new Swiper('.destaque-slider', {
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: '.destaque-arrow-right',
                prevEl: '.destaque-arrow-left',
            },
            thumbs: {
                swiper: thumbs,
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });

        // ======================================
        // Função da pesquisa
        // ======================================


        const btn = document.querySelector(".pc-search-btn");
        const field = document.querySelector(".pc-search-field");
        const input = document.getElementById("pc-search-input");
        const results = document.getElementById("pc-search-results");

        if (!btn || !input || !results) return;

        // Abre e fecha o campo de busca
        btn.addEventListener("click", () => {
            field.classList.toggle("active");
            input.focus();
        });

        // Busca dinâmica
        let timer;
        input.addEventListener("keyup", function () {
            clearTimeout(timer);
            const term = this.value.trim();

            if (term.length < 2) {
                results.innerHTML = "";
                results.classList.remove("active");
                return;
            }

            timer = setTimeout(() => {
                fetch(`${pc_search.ajax_url}?action=pc_search_posts&s=${encodeURIComponent(term)}`)
                    .then(res => res.json())
                    .then(data => {
                        if (data.length > 0) {
                            results.innerHTML = data
                                .map(
                                    post => `
                                    <a href="${post.url}">
                                    <img src="${post.thumb}" alt="${post.title}" class="pc-search-thumb" />
                                    <span class="pc-search-title">${post.title}</span>
                                    </a>`
                                )
                                .join("");
                        } else {
                            results.innerHTML = `<div class="no-results">Nenhum resultado encontrado.</div>`;
                        }
                        results.classList.add("active");
                    })
                    .catch(() => {
                        results.innerHTML = `<div class="no-results">Erro na pesquisa.</div>`;
                        results.classList.add("active");
                    });
            }, 400);
        });

        var swiper = new Swiper(".mySwiperAniversary", {
        slidesPerView: 2,
        spaceBetween: 15,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        autoplay: true,
        pagination: false,

        breakpoints: {
            640: {
            slidesPerView: 2,
            spaceBetween: 20,
            },
            768: {
            slidesPerView: 3,
            spaceBetween: 40,
            },
            1024: {
            slidesPerView: 4,
            spaceBetween: 50,
            },
        },
        });


    });
});



// document.addEventListener("DOMContentLoaded", function () {

//     const dialog = document.getElementById("popupDialog");
//     const closeBtn = document.getElementById("popupClose");

//     if (!dialog) return;

//     dialog.showModal();

//     closeBtn.addEventListener("click", function () {
//         dialog.close();
//     });

//     dialog.addEventListener("click", function (e) {
//         const rect = dialog.getBoundingClientRect();
//         const isInside =
//             rect.top <= e.clientY &&
//             e.clientY <= rect.top + rect.height &&
//             rect.left <= e.clientX &&
//             e.clientX <= rect.left + rect.width;

//         if (!isInside) {
//             dialog.close();
//         }
//     });

// });

document.addEventListener("DOMContentLoaded", function () {

    const dialog = document.getElementById("popupDialog");
    const closeBtn = document.getElementById("popupClose");

    if (!dialog) return;

    // 🔒 Se já abriu nesta sessão, não abrir novamente
    if (sessionStorage.getItem("popupAberto")) {
        return;
    }

    dialog.showModal();

    // Marca como aberto na sessão
    sessionStorage.setItem("popupAberto", "true");

    closeBtn.addEventListener("click", function () {
        dialog.close();
    });

    dialog.addEventListener("click", function (e) {
        const rect = dialog.getBoundingClientRect();
        const isInside =
            rect.top <= e.clientY &&
            e.clientY <= rect.top + rect.height &&
            rect.left <= e.clientX &&
            e.clientX <= rect.left + rect.width;

        if (!isInside) {
            dialog.close();
        }
    });

});